module.exports = __webpack_public_path__ + "static/media/aklinikka-logo@2x.ffd50243.png";